exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".image-container{display:flex;justify-content:space-around}.image-box{text-align:center}.image-box img{max-width:100%;height:100px}.image-box button{cursor:pointer}", ""]);

// exports
